import React from 'react';
import Store from '../store/Store';

type DialogType = 'warning' | 'ok' | 'info' | 'error';

interface ConfirmDialogParams {
	type?: DialogType;
	title: string;
	text: string;
	icon?: React.ReactNode;
	confirmLabel: string;
	cancelLabel?: string;
	confirmFirst?: boolean;
	onConfirm: () => Promise<void> | void;
}

interface MessageDialogParams {
	type?: DialogType;
	title: string;
	text: string;
	icon?: React.ReactNode;
	buttonLabel?: string;
	onClose?: () => Promise<void> | void;
}

export function useDialog() {
	const showConfirmDialog = ({
		type = 'warning',
		title,
		text,
		icon,
		confirmLabel,
		cancelLabel = 'Nein, Abbrechen',
		confirmFirst = false,
		onConfirm,
	}: ConfirmDialogParams) => {
		Store.setPopupDialog({
			type,
			title,
			text,
			icon,
			buttons: confirmFirst
				? [confirmLabel, cancelLabel]
				: [cancelLabel, confirmLabel],
			time: 0,
			onAction: async (value: string) => {
				if (value === confirmLabel) {
					await onConfirm();
				}
			},
		});
	};

	const showMessageDialog = ({
		type = 'ok',
		title,
		text,
		icon,
		buttonLabel = 'Fertig',
		onClose,
	}: MessageDialogParams) => {
		Store.setPopupDialog({
			type,
			title,
			text,
			icon,
			buttons: [buttonLabel],
			time: 0,
			onAction: async () => {
				Store.setPopupDialog(undefined);
				await onClose?.();
			},
		});
	};

	return {
		showConfirmDialog,
		showMessageDialog,
	};
}
